
export const createSiteRouter = async () => {

  const siteProfile = `${__SITE_PROFILE__}`

  return [{
      path: '/',
      name: 'Home',
      component: () => import(`../pages/home/${siteProfile}.vue`)
    },
    {
      path: '/courses',
      name: 'CourseSystem',
      component: () => import(`../pages/courseSystem/${siteProfile}.vue`)
    },
    {
      path: '/teachers',
      name: 'TeacherStrength',
      component: () => import(`../pages/teacher/${siteProfile}.vue`)
    },
    {
      path: '/help/classroom',
      name: 'Classroom',
      component: () => import(`../pages/howToAttend/${siteProfile}.vue`)
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('../pages/NotFound.vue')
    }
  ]

}
